export default function CarRentalBanner() {
  return (
    <section className="card-minimal p-6 bg-white/80 text-center">
      <a
        href="https://www.discovercars.com/?a_aid=BetoWH13&a_bid=f29909e9"
        target="_blank"
        rel="noreferrer nofollow sponsored"
        className="inline-block"
      >
        <img
          src="https://discover-car-hire.postaffiliatepro.com/accounts/default1/bunyh71e/f29909e9.jpg"
          alt="DiscoverCars.com"
          title="DiscoverCars.com"
          width={728}
          height={90}
          className="w-full h-auto max-w-[728px]"
        />
      </a>
      <img
        src="https://discover-car-hire.postaffiliatepro.com/scripts/iunyh71e?a_aid=BetoWH13&a_bid=f29909e9"
        width={1}
        height={1}
        alt=""
        style={{ border: 0 }}
        className="absolute opacity-0"
      />
    </section>
  );
}
